import {
    buildOutliersConfigSlice,
    OutliersWidgetConfigPayloadType,
} from 'widgets/outliers/store/config/configSlice';
import { combineReducers } from 'redux';
import { createWidgetsReducer } from 'widgets/store/widgetsReducerFactory';
import { WidgetType } from 'widgets/WidgetType';
import { OutliersWidgetState } from 'widgets/outliers/store/OutliersWidgetState';

const { reducer: configReducer } = buildOutliersConfigSlice();

const outliersWidgetReducer = combineReducers<OutliersWidgetState>({
    config: configReducer,
});

export const outliersWidgetsReducer = createWidgetsReducer<
    OutliersWidgetState,
    OutliersWidgetConfigPayloadType
>(WidgetType.OUTLIERS_WIDGET, outliersWidgetReducer);
